(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Picto)
});

// UNUSED EXPORTS: Accessories104, Accessories56, AccountsPayments104, AccountsPayments56, AdaptiveCollaborationCloud104, AdaptiveCollaborationCloud56, AdaptiveCollaborationPhone104, AdaptiveCollaborationPhone56, AdaptiveNetworksCentre104, AdaptiveNetworksCentre56, Add104, Add56, AddPhone104, AddPhone56, AdultFemale104, AdultFemale56, AdultMale104, AdultMale56, AndrogynousPersonOne104, AndrogynousPersonOne56, AndrogynousPersonTwo104, AndrogynousPersonTwo56, AppMyTelstra104, AppMyTelstra56, Appointment104, Appointment56, Arts104, Arts56, Australia104, Australia56, AvatarAdultFemale104, AvatarAdultFemale56, AvatarAdultMale104, AvatarAdultMale56, AvatarAndrogynousPersonOne104, AvatarAndrogynousPersonOne56, AvatarAndrogynousPersonTwo104, AvatarAndrogynousPersonTwo56, AvatarBaby104, AvatarBaby56, AvatarBaldMale104, AvatarBaldMale56, AvatarBaldManBeard104, AvatarBaldManBeard56, AvatarBaldManGlasses104, AvatarBaldManGlasses56, AvatarBeardMan104, AvatarBeardMan56, AvatarBoy104, AvatarBoy56, AvatarCat104, AvatarCat56, AvatarChild104, AvatarChild56, AvatarDoctorFemale104, AvatarDoctorFemale56, AvatarDog104, AvatarDog56, AvatarElderlyFemale104, AvatarElderlyFemale56, AvatarElderlyMale104, AvatarElderlyMan56, AvatarFemaleOveralls104, AvatarFemaleOveralls56, AvatarFirstNationsFemale104, AvatarFirstNationsFemale56, AvatarFirstNationsMale104, AvatarFirstNationsMale56, AvatarGirlPigTails104, AvatarGirlPigTails56, AvatarHatAndSunglasses104, AvatarHatAndSunglasses56, AvatarHijabFemale104, AvatarHijabFemale56, AvatarLady104, AvatarLady56, AvatarLadyGlasses104, AvatarLadyGlasses56, AvatarLonghairGirl104, AvatarLonghairGirl56, AvatarMiddleAgeFemale104, AvatarMiddleAgeFemale56, AvatarMiddleAgeMan104, AvatarMiddleAgeMan56, AvatarMoustacheMan104, AvatarMoustacheMan56, AvatarOutbackMale104, AvatarOutbackMale56, AvatarPerson104, AvatarPerson56, AvatarPersonAfro104, AvatarPersonAfro56, AvatarPersonBusiness104, AvatarPersonBusiness56, AvatarSunSmartMale104, AvatarSunSmartMale56, AvatarTeen104, AvatarTeen56, AvatarTeenFemale104, AvatarTeenFemale56, AvatarTeenGirl104, AvatarTeenGirl56, AvatarTelstraHardHat104, AvatarTelstraHardHat56, AvatarTurbanMale104, AvatarTurbanMale56, AvatarYoungAdultMale104, AvatarYoungAdultMale56, Baby104, Baby56, BaldMale104, BaldMale56, Bank104, Bank56, BillEmails104, BillEmails56, BillOverview104, BillOverview56, BillPaid104, BillPaid56, BroadbandEnterpriseSim104, BroadbandEnterpriseSim56, BroadbandHome104, BroadbandHome56, BroadbandMobile104, BroadbandMobile56, BroadbandMobileSim104, BroadbandMobileSim56, Building104, Building56, Bundles104, Bundles56, Bus104, Bus56, BusinessIdeas104, BusinessIdeas56, BusinessOperation104, BusinessOperation56, BusinessSoftware104, BusinessSoftware56, BusinessStrategy104, BusinessStrategy56, Calendar104, Calendar56, CardAdded104, CardAdded56, Cart104, Cart56, Cat104, Cat56, ChangePlan104, ChangePlan56, Charger104, Charger56, Chat104, Chat56, Child104, Child56, ClickAndCollect104, ClickAndCollect56, Clock104, Clock56, Compare104, Compare56, CoverageMap104, CoverageMap56, CoverageMobile104, CoverageMobile56, CoverageNetwork104, CoverageNetwork56, Cyclone104, Cyclone56, CycloneandStorms104, CycloneandStorms56, DataPacks104, DataPacks56, DataPool104, DataPool56, Deal104, Deal56, Delivery104, Delivery56, DeviceLocator104, DeviceLocator56, DeviceProtect104, DeviceProtect56, Devices104, Devices56, Disruptions104, Disruptions56, DoctorFemale104, DoctorFemale56, Document104, Document56, Dog104, Dog56, Download104, Download56, DownloadDoc104, DownloadDoc56, DriverLicence104, DriverLicence56, ESIM104, ESIM56, EarnPoints104, EarnPoints56, Earthquake104, Earthquake56, Edit104, Edit56, ElderlyFemale104, ElderlyFemale56, ElderlyMale104, ElderyMale56, Electricity104, Electricity56, ElectricityMeter104, ElectricityMeter56, EmptyStateBox104, EmptyStateBox56, EmptyStateTray104, EmptyStateTray56, Energy104, Energy56, EnergySolar104, EnergySolar56, EnergyWind104, EnergyWind56, EnterpriseCloud104, EnterpriseCloud56, Entertainment104, Entertainment56, EntertainmentPackages104, EntertainmentPackages56, Error104, Error56, ErrorServer104, ErrorServer56, FailedConnection104, FailedConnection56, Feedback104, Feedback56, FieldExecution104, FieldExecution56, Fire104, Fire56, FirstNationsFemale104, FirstNationsFemale56, FirstNationsMale104, FirstNationsMale56, Floods104, Floods56, Foxtel104, Foxtel56, Gaming104, Gaming56, Gas104, Gas56, GasMeter104, GasMeter56, GetInTouch104, GetInTouch56, Gift104, Gift56, GlobalMapMarker104, GlobalMapMarker56, GlobalNetworks104, GlobalNetworks56, GreenEnergy104, GreenEnergy56, Headphones104, Headphones56, Help104, Help56, HijabFemale104, HijabFemale56, History104, History56, Home104, Home56, IDGeneric104, IDGeneric56, IOT104, IOT56, IOTUpdate104, IOTUpdate56, IRCallingPack104, IRCallingPack56, Information104, Information56, Installation104, Installation56, InternationalCalls104, InternationalCalls56, InternationalMobileCalls104, InternationalMobileCalls56, Internet104, Internet56, InternetCalls104, InternetCalls56, InternetExtras104, InternetExtras56, InternetMobileCalls104, InternetMobileCalls56, InternetOptimiser104, InternetOptimiser56, Landline104, Landline56, Laptop104, Laptop56, LatencyOptimiser104, LatencyOptimiser56, LatestInvoices104, LatestInvoices56, Legal104, Legal56, MBBRoaming104, MBBRoaming56, MIddleAgeFemale56, Mail104, Mail56, ManageDevicesAccess104, ManageDevicesAccess56, ManageDevicesEnrolled104, ManageDevicesEnrolled56, ManageDevicesLock104, ManageDevicesLock56, ManageDevicesMonitor104, ManageDevicesMonitor56, ManageDevicesSettings104, ManageDevicesSettings56, ManageDevicesShield104, ManageDevicesShield56, ManageDevicesUnenrolled104, ManageDevicesUnenrolled56, MapMarker104, MapMarker56, Membership104, Membership56, MiddleAgeFemale104, MiddleAgeMale104, MiddleAgeMale56, Mobile104, Mobile56, MobileAccelerator104, MobileAccelerator56, MobileSim104, MobileSim56, MoveHouse104, MoveHouse56, Movies104, Movies56, Music104, Music56, NBN104, NBN56, NBNHealth104, NBNHealth56, NetworkSpeed104, NetworkSpeed56, NewMobile104, NewMobile56, News104, News56, NoBills104, NoBills56, NotificationCall104, NotificationCall56, NotificationCentre104, NotificationCentre56, NotificationEmail104, NotificationEmail56, NotificationMessage104, NotificationMessage56, NotificationReminder104, NotificationReminder56, Notifications104, Notifications56, OneNumber104, OneNumber56, OutbackMale104, OutbackMale56, PassportAustralia104, PassportAustralia56, PassportInternational104, PassportInternational56, PayPhone104, PayPhone56, Payment104, Payment56, PaymentCalendar104, PaymentCalendar56, PaymentHelp104, PaymentHelp56, PaymentPlan104, PaymentPlan56, PeaceOfMind104, PeaceOfMind56, Perfect104, Perfect56, Phone104, Phone56, PhoneCase104, PhoneCase56, PhoneSound104, PhoneSound56, Picto4G104, Picto4G56, Picto4GX104, Picto4GX56, Picto5G104, Picto5G56, Pin104, Pin56, Placeholder104, Placeholder56, PoleInspection104, PoleInspection56, PortMobile104, PortMobile56, PortPhone104, PortPhone56, PortSIM104, PortSIM56, PostPaid104, PostPaid56, PrePaid104, PrePaid56, Preferences104, Preferences56, PriorityAssistance104, PriorityAssistance56, Profile104, Profile56, ProfileCompletion104, ProfileCompletion56, PromoCombined104, PromoCombined56, PromoData104, PromoData56, PromoDiscount104, PromoDiscount56, RaisedSurface104, RaisedSurface56, Receipt104, Receipt56, RecurringPayment104, RecurringPayment56, RedeemPoints104, RedeemPoints56, Rewards104, Rewards56, Roaming104, Roaming56, RoamingOn104, RoamingOn56, SIM104, SIM56, SMS104, SMS56, Satellite104, Satellite56, Search104, Search56, Security104, Security56, SecurityHome104, SecurityHome56, SecurityInternet104, SecurityInternet56, SecurityMobile104, SecurityMobile56, SendOldPhone104, SendOldPhone56, Services104, Services56, Settings104, Settings56, Share104, Share56, SharedWiFi104, SharedWiFi56, Shop104, Shop56, Signin104, Signin56, SmartHome104, SmartHome56, SmartWiFiBooster104, SmartWiFiBooster56, SomethingWentWrong104, SomethingWentWrong56, SpeedOptimiser104, SpeedOptimiser56, Sporting104, Sporting56, StarlinkSatellite104, StarlinkSatellite56, Store104, Store56, StoreAddress104, StoreAddress56, StoreClock104, StoreClock56, StoreSuccess104, StoreSuccess56, Storm104, Storm56, Success104, Success56, SunSmartMale104, SunSmartMale56, SupportPhone104, SupportPhone56, Swipe104, Swipe56, SwitchOff104, SwitchOff56, SwitchOn104, SwitchOn56, TV104, TV56, Tablet104, Tablet56, TabletSim104, TabletSim56, Technician104, Technician56, Teen104, Teen56, TeenFemale104, TeenFemale56, Telstra104, Telstra56, TelstraAir104, TelstraAir56, TelstraConnect104, TelstraConnect56, TelstraLocator104, TelstraLocator56, TelstraPlus104, TelstraPlus56, TelstraTV104, TelstraTV56, Ticket104, Ticket56, TrackOrder104, TrackOrder56, TradeIn104, TradeIn56, Train104, Train56, TransferRequest104, TransferRequest56, Translate104, Translate56, Troubleshoot104, Troubleshoot56, TruckFire104, TruckFire56, TurbanMale104, TurbanMale56, UnderseaCable104, UnderseaCable56, UnderseaCableNetwork104, UnderseaCableNetwork56, UnifiedComms104, UnifiedComms56, Unlimited104, Unlimited56, Upgrade104, Upgrade56, UploadDoc104, UploadDoc56, VIP104, VIP56, Video104, Video56, Warning104, Warning56, Watch104, Watch56, WeCare104, WeCare56, WhiteLabelAboutApp104, WhiteLabelAboutApp56, WhiteLabelAccountsPayments104, WhiteLabelAccountsPayments56, WhiteLabelBank104, WhiteLabelBank56, WhiteLabelBillOverview104, WhiteLabelBillOverview56, WhiteLabelBillPaid104, WhiteLabelBillPaid56, WhiteLabelBroadbandMobile104, WhiteLabelBroadbandMobile56, WhiteLabelCardAdded104, WhiteLabelCardAdded56, WhiteLabelChangePlan104, WhiteLabelChangePlan56, WhiteLabelChat104, WhiteLabelChat56, WhiteLabelDataPacks104, WhiteLabelDataPacks56, WhiteLabelDataPool104, WhiteLabelDataPool56, WhiteLabelDelivery104, WhiteLabelDelivery56, WhiteLabelDownload104, WhiteLabelDownload56, WhiteLabelESIM104, WhiteLabelESIM56, WhiteLabelEmptyStateBox104, WhiteLabelEmptyStateBox56, WhiteLabelError104, WhiteLabelError56, WhiteLabelFailedConnection104, WhiteLabelFailedConnection56, WhiteLabelFeedback104, WhiteLabelFeedback56, WhiteLabelGift104, WhiteLabelGift56, WhiteLabelHelp104, WhiteLabelHelp56, WhiteLabelInformation104, WhiteLabelInformation56, WhiteLabelInstallation104, WhiteLabelInstallation56, WhiteLabelInternationalCalls104, WhiteLabelInternationalCalls56, WhiteLabelInternationalMobileCall104, WhiteLabelInternationalMobileCall56, WhiteLabelInternet104, WhiteLabelInternet56, WhiteLabelMail104, WhiteLabelMail56, WhiteLabelMobile104, WhiteLabelMobile56, WhiteLabelMobileAndTablet104, WhiteLabelMobileAndTablet56, WhiteLabelNetworkSpeed104, WhiteLabelNetworkSpeed56, WhiteLabelPayment104, WhiteLabelPayment56, WhiteLabelPaymentCalendar104, WhiteLabelPaymentCalendar56, WhiteLabelPaymentHelp104, WhiteLabelPaymentHelp56, WhiteLabelPin104, WhiteLabelPin56, WhiteLabelPlaceholder104, WhiteLabelPlaceholder56, WhiteLabelPostPaid104, WhiteLabelPostPaid56, WhiteLabelPrePaid104, WhiteLabelPrePaid56, WhiteLabelProfile104, WhiteLabelProfile56, WhiteLabelPromoCombined104, WhiteLabelPromoCombined56, WhiteLabelPromoData104, WhiteLabelPromoData56, WhiteLabelPromoDiscount104, WhiteLabelPromoDiscount56, WhiteLabelReceipt104, WhiteLabelReceipt56, WhiteLabelRecurringPayment104, WhiteLabelRecurringPayment56, WhiteLabelRoaming104, WhiteLabelRoaming56, WhiteLabelSMS104, WhiteLabelSMS56, WhiteLabelSecurity104, WhiteLabelSecurity56, WhiteLabelServices104, WhiteLabelServices56, WhiteLabelSettings104, WhiteLabelSettings56, WhiteLabelSignIn104, WhiteLabelSignIn56, WhiteLabelSomethingWentWrong104, WhiteLabelSomethingWentWrong56, WhiteLabelSuccess104, WhiteLabelSuccess56, WhiteLabelSupportPhone104, WhiteLabelSupportPhone56, WhiteLabelTechnician104, WhiteLabelTechnician56, WhiteLabelTrackOrder104, WhiteLabelTrackOrder56, WhiteLabelWarning104, WhiteLabelWarning56, WhiteLabelWeCare104, WhiteLabelWeCare56, WhiteLabelWiFi104, WhiteLabelWiFi56, WiFi104, WiFi56, WiFiBooster104, WiFiBooster56, Window104, Window56, YoungAdultMale104, YoungAdultMale56

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/Picto/Picto.tsx


var _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/**
 *
 * Illustrations help convey complex ideas in a simple way.
 * They should be meaningful and reflect a user's context and emotional state.
 * We use them to make technical information feel more human, and add some personality to the way we communicate.
 *
 * [View the Picto documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Pictograms+and+Illustrations)
 *
 * @version 1.0.0
 */

function Picto(props) {
  var className = props.className,
    children = props.children,
    other = objectWithoutProperties_default()(props, _excluded);
  var classes = classnames_default()('able-picto', className);
  var childProps = _objectSpread({
    className: classes,
    focusable: 'false',
    'aria-hidden': 'true'
  }, other);
  var SelectedPictogram = function SelectedPictogram() {
    return /*#__PURE__*/(0,external_react_.cloneElement)(children, childProps);
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(SelectedPictogram, {});
}
/* harmony default export */ const Picto_Picto = (Picto);
// EXTERNAL MODULE: ./src/Picto/Picto.scss
var src_Picto_Picto = __webpack_require__(493);
;// ./src/Picto/index.ts



/* harmony default export */ const src_Picto = (Picto_Picto);

/***/ }),

/***/ 493:
/***/ (() => {



/***/ }),

/***/ 1116:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 1217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export iconVersion */
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1116);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2462);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__);


var _excluded = ["className", "developmentUrl", "icon", "screenReaderContent", "size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


var iconVersion = 12;

/**
 * Icons are symbols that provide visual context and communicate function
 * or intent in a universal way.
 *
 * Available icon names are listed at https://confluence.tools.telstra.com/display/DCSYS/Icons
 *
 * @version 1.0.0
 */
function Icon(props) {
  var className = props.className,
    developmentUrl = props.developmentUrl,
    icon = props.icon,
    screenReaderContent = props.screenReaderContent,
    _props$size = props.size,
    size = _props$size === void 0 ? '24' : _props$size,
    other = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(props, _excluded);
  var href = developmentUrl || "//www.telstra.com.au/content/dam/tcom/able/able-sprites.svg?v".concat(iconVersion);
  var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()('able-icon', "able-icon--".concat(size), className || null);
  var deprecatedIcons = {
    Visibility: ['ToggleOff, ToggleOn'],
    ScanBarcode: ['Scan']
  };
  var replacementIcons = icon;
  if (deprecatedIcons.hasOwnProperty(icon)) {
    replacementIcons = deprecatedIcons[icon].join(' ');
    console.warn("Icon ".concat(icon, " is deprecated, and will be removed in July 2024. Use '").concat(replacementIcons, "' instead."));
  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", _objectSpread(_objectSpread(_objectSpread({
    className: classes,
    role: "img",
    "aria-hidden": !screenReaderContent ? 'true' : 'false'
  }, screenReaderContent && {
    'aria-label': screenReaderContent
  }), {}, {
    focusable: "false"
  }, other), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("use", {
      href: "".concat(href, "#").concat(icon)
    })
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 2015:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 2462:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 2551:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_Checkbox)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(6168);
// EXTERNAL MODULE: ./src/Picto/index.ts + 1 modules
var src_Picto = __webpack_require__(431);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/_shared/_partials/SelectableInput/index.tsx


var _excluded = ["checked", "children", "className", "componentClassName", "description", "developmentUrl", "events", "hasIndicator", "iconName", "id", "imagePath", "label", "name", "Picto", "role", "type", "value", "variant", "aria-describedby"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





var SelectableInputImageClassSuffix = function SelectableInputImageClassSuffix(props) {
  var variantIsComfortable = props.variant === 'Comfortable';
  var classNameSuffix = '';
  if (variantIsComfortable) {
    if (props.Picto || props.imagePath) {
      classNameSuffix += '--Pictogram';
    }
    if (props.iconName) {
      classNameSuffix += '--Icon';
    }
  }
  return classNameSuffix;
};

/**
 * SelectableInput is the props and functionality behind checkbox and radio button inputs.
 * It has no styling.
 *
 * @version 1.0.0
 */
var SelectableInput = /*#__PURE__*/(0,external_react_.forwardRef)(function (props, ref) {
  var checked = props.checked,
    children = props.children,
    className = props.className,
    componentClassName = props.componentClassName,
    description = props.description,
    developmentUrl = props.developmentUrl,
    events = props.events,
    hasIndicator = props.hasIndicator,
    iconName = props.iconName,
    id = props.id,
    imagePath = props.imagePath,
    label = props.label,
    name = props.name,
    Picto = props.Picto,
    role = props.role,
    type = props.type,
    value = props.value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'Compact' : _props$variant,
    inputAriaDescribedBy = props['aria-describedby'],
    other = objectWithoutProperties_default()(props, _excluded);
  var prefilledInputId = (0,external_react_.useId)();
  var inputId = props.id || prefilledInputId;
  var variantIsComfortable = variant === 'Comfortable';
  var classes = classnames_default()("".concat(componentClassName), className || null);
  var imageString = function imageString() {
    if (imagePath && variantIsComfortable) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)("img", {
        src: imagePath,
        alt: ""
      });
    } else if (Picto && variantIsComfortable) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(src_Picto["default"], {
        children: Picto
      });
    } else if (iconName && variantIsComfortable) {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
        icon: iconName,
        developmentUrl: developmentUrl,
        size: "24"
      });
    }
    return null;
  };
  var descriptionString = function descriptionString() {
    if (description && variantIsComfortable) {
      if (Array.isArray(description) && (type === 'checkbox' || type === 'radio')) {
        return description.map(function (descriptionLine) {
          return /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
            id: "descriptionID",
            children: descriptionLine
          }, descriptionLine);
        });
      } else {
        return /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
          children: description
        });
      }
    }
    return false;
  };
  var selectionStateSvg = null;
  if (hasIndicator) {
    if (type === 'checkbox') {
      selectionStateSvg = /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.54,14.81l8-8a1.09,1.09,0,0,1,1.54,0l0,0a1.1,1.1,0,0,1,0,1.54l-8.78,8.78s0,0,0,0a1.12,1.12,0,0,1-.79.33h0a1.15,1.15,0,0,1-.41-.08,1.08,1.08,0,0,1-.39-.25L4.86,13.31a1.13,1.13,0,0,1,.8-1.92,1.11,1.11,0,0,1,.79.33Z"
        })
      });
    } else if (type === 'radio') {
      selectionStateSvg = /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "16",
          cy: "16",
          r: "7"
        })
      });
    }
  }
  var InlineComfortableIcon = function InlineComfortableIcon() {
    if (iconName && variant === 'InlineComfortable') {
      return /*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
        icon: iconName,
        developmentUrl: developmentUrl
      });
    }
    return null;
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("div", _objectSpread(_objectSpread({
    className: classes
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("input", _objectSpread(_objectSpread({
      id: inputId,
      ref: ref,
      type: type,
      name: name || inputId,
      value: value,
      checked: checked,
      role: role
    }, events), {}, {
      "aria-describedby": inputAriaDescribedBy
    })), /*#__PURE__*/(0,jsx_runtime_.jsxs)("label", {
      htmlFor: inputId,
      children: [InlineComfortableIcon(), label, descriptionString(), selectionStateSvg]
    }), imageString(), children]
  }));
});
/* harmony default export */ const _partials_SelectableInput = (SelectableInput);
;// ./src/Checkbox/Checkbox.tsx

function Checkbox_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Checkbox_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Checkbox_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Checkbox_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }




/**
 * A standalone checkbox is a single selection control that allows a user to
 * change a setting between selected or unselected state. The checkbox is
 * always followed by a label that describes what will happen after users make a selection.
 *
 * [View the Checkbox pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Checkbox)
 *
 * @version 1.0.0
 */

var Checkbox = /*#__PURE__*/(0,external_react_.forwardRef)(function (props, ref) {
  var componentClassname = "able-Checkbox--".concat(props.variant ? props.variant : 'Compact').concat(SelectableInputImageClassSuffix(props));
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_SelectableInput, Checkbox_objectSpread({
    componentClassName: componentClassname,
    ref: ref,
    type: "checkbox",
    hasIndicator: true
  }, props));
});
Checkbox.displayName = 'Checkbox';
/* harmony default export */ const Checkbox_Checkbox = (Checkbox);
// EXTERNAL MODULE: ./src/Checkbox/Checkbox.scss
var src_Checkbox_Checkbox = __webpack_require__(8029);
;// ./src/Checkbox/index.ts


/* harmony default export */ const src_Checkbox = (Checkbox_Checkbox);

/***/ }),

/***/ 5133:
/***/ (() => {



/***/ }),

/***/ 5657:
/***/ (() => {



/***/ }),

/***/ 6168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1217);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5133);
/* harmony import */ var _Icon_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Icon_scss__WEBPACK_IMPORTED_MODULE_0__);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A);

/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8029:
/***/ (() => {



/***/ }),

/***/ 8732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ src_CheckboxGroup)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
;// ./src/_shared/_helpers/randomNum.ts
/**
 * Generates a random number
 *
 * @param {number} [min=10000] - the minimum number for generatation
 * @param {number} [max=99999] - the maxiumum number for generatation
 *
 * @returns {number} random number between min and max
 */
var randomNum = function randomNum() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10000;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 99999;
  var randomNumber = Math.random() * (max - min) + min;
  return Math.floor(randomNumber);
};
/* harmony default export */ const _helpers_randomNum = (randomNum);
;// external "@babel/runtime/helpers/typeof"
const typeof_namespaceObject = require("@babel/runtime/helpers/typeof");
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_namespaceObject);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// ./src/_shared/constants.tsx
var SELECTION_REQUIRED_DEFAULT_TEXT = 'Selection required.';

;// external "@babel/runtime/helpers/toConsumableArray"
const toConsumableArray_namespaceObject = require("@babel/runtime/helpers/toConsumableArray");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray_namespaceObject);
;// ./src/_shared/_helpers/isValidErrorMessageProp.ts


var allowedElementTypes = ['span', 'string', 'Symbol(react.fragment)'];
var _parseChildrenToFindNonSpanElements = function parseChildrenToFindNonSpanElements(children, listOfElements) {
  external_react_.Children.map(children, function (child) {
    if (! /*#__PURE__*/(0,external_react_.isValidElement)(child)) {
      return '';
    }
    if (child.props.children) {
      var props = {
        children: _parseChildrenToFindNonSpanElements(child.props.children, listOfElements)
      };
      child = /*#__PURE__*/(0,external_react_.cloneElement)(child, props);
    }
    listOfElements.push(child.type.toString());
    return child.type.toString();
  });
  return listOfElements;
};
var isValidErrorMessageProp = function isValidErrorMessageProp(children) {
  var listOfElements = [];
  _parseChildrenToFindNonSpanElements(children, listOfElements);
  var listOfDisallowedElementsForErrorMessaging = listOfElements.filter(function (elementType) {
    return !allowedElementTypes.includes(elementType);
  });
  if (listOfDisallowedElementsForErrorMessaging.length) {
    listOfDisallowedElementsForErrorMessaging = listOfDisallowedElementsForErrorMessaging.map(function (element) {
      return "<".concat(element, ">");
    });
    var disallowedElementsForErrorMessagingAsAString = toConsumableArray_default()(new Set(listOfDisallowedElementsForErrorMessaging)).join(', ');
    var errorMessage = listOfDisallowedElementsForErrorMessaging.length > 1 ? "Elements ".concat(disallowedElementsForErrorMessagingAsAString, " are not allowed") : "Element ".concat(disallowedElementsForErrorMessagingAsAString, " is not allowed");
    return {
      isValidErrorMessage: false,
      invalidErrorMessagePropErrorText: errorMessage
    };
  }
  return {
    isValidErrorMessage: true,
    invalidErrorMessagePropErrorText: ''
  };
};
var throwErrorIfInvalidErrorMessageProp = function throwErrorIfInvalidErrorMessageProp(errorMessageProp, errorMessagePropName) {
  var _isValidErrorMessageP = isValidErrorMessageProp(errorMessageProp),
    isValidErrorMessage = _isValidErrorMessageP.isValidErrorMessage,
    invalidErrorMessagePropErrorText = _isValidErrorMessageP.invalidErrorMessagePropErrorText;
  if (!isValidErrorMessage) {
    throw new Error("".concat(invalidErrorMessagePropErrorText, " for ").concat(errorMessagePropName, ". Please provide a string or a span element. Nested spans are allowed for accessibility purposes."));
  }
};

// EXTERNAL MODULE: ./src/Icon/index.ts
var Icon = __webpack_require__(6168);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/_shared/_partials/SelectableInputGroup/index.tsx



var _excluded = ["children", "className", "componentClassName", "developmentUrl", "errorText", "groupLabel", "helpText", "id", "imageType", "invalid", "name", "variant", "legendRef", "legendId", "describedById", "style", "isRadioButtonGroup"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }






/**
 * Selectable Input Group is a container for Selectable Inputs.
 * It consists of a group label, and optional help text
 * to provide additional selection requirements.
 *
 * @version 1.0.0
 */

function SelectableInputGroup(props) {
  var children = props.children,
    className = props.className,
    componentClassName = props.componentClassName,
    developmentUrl = props.developmentUrl,
    errorText = props.errorText,
    groupLabel = props.groupLabel,
    helpText = props.helpText,
    id = props.id,
    _props$imageType = props.imageType,
    imageType = _props$imageType === void 0 ? 'None' : _props$imageType,
    _props$invalid = props.invalid,
    invalid = _props$invalid === void 0 ? false : _props$invalid,
    name = props.name,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'Compact' : _props$variant,
    legendRef = props.legendRef,
    legendId = props.legendId,
    describedById = props.describedById,
    style = props.style,
    isRadioButtonGroup = props.isRadioButtonGroup,
    other = objectWithoutProperties_default()(props, _excluded);
  var errorId = "".concat((0,external_react_.useId)(), "--error-id");
  var computedVariant = variant === 'Default' ? 'Compact' : variant;
  var groupLabelExists = typeof_default()(groupLabel) === 'object' && groupLabel.props.label || typeof groupLabel === 'string' && groupLabel !== '';
  var getAriaDescribedBy = function getAriaDescribedBy() {
    if (!groupLabelExists && describedById) {
      return {
        'aria-describedby': describedById
      };
    }
    return {};
  };
  var classes = classnames_default()(className, "".concat(componentClassName));
  var modifiedChildren = function modifiedChildren() {
    if (children) {
      var applyAriaDescribedByIdToFirstChild = invalid && groupLabelExists && errorId;
      return external_react_.Children.map(children, function (child, index) {
        var _child$props = child.props,
          iconName = _child$props.iconName,
          imagePath = _child$props.imagePath,
          Picto = _child$props.Picto;
        var modifiedProps = {
          iconName: imageType === 'Icon' ? iconName : undefined,
          imagePath: imageType === 'Custom' ? imagePath : undefined,
          Picto: imageType === 'Picto' || imageType === 'Pictogram' ? Picto : undefined,
          'aria-describedby': index === 0 && applyAriaDescribedByIdToFirstChild ? errorId : undefined
        };
        return /*#__PURE__*/(0,external_react_.cloneElement)(child, _objectSpread({
          developmentUrl: developmentUrl,
          name: name,
          variant: computedVariant
        }, modifiedProps));
      });
    }
    throw new Error('SelectableInputGroup requires children.');
  };
  var _isValidErrorMessageP = isValidErrorMessageProp(errorText),
    isValidErrorMessage = _isValidErrorMessageP.isValidErrorMessage,
    invalidErrorMessagePropErrorText = _isValidErrorMessageP.invalidErrorMessagePropErrorText;
  if (!isValidErrorMessage) {
    console.error("".concat(invalidErrorMessagePropErrorText, " for errorText. Please provide a string or a span element. Nested spans are allowed for accessibility purposes."));
  }
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("div", _objectSpread(_objectSpread({
    className: classes
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsx)("fieldset", _objectSpread(_objectSpread({}, getAriaDescribedBy()), {}, {
      style: style,
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)(jsx_runtime_.Fragment, {
        children: [groupLabelExists ? /*#__PURE__*/(0,jsx_runtime_.jsxs)("legend", {
          ref: legendRef,
          id: legendId,
          tabIndex: legendId || legendRef && legendRef.current ? -1 : undefined,
          children: [groupLabel, helpText ? /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
            children: helpText
          }) : '', invalid ? /*#__PURE__*/(0,jsx_runtime_.jsxs)("span", {
            id: errorId,
            className: "".concat(componentClassName, "__error"),
            children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
              icon: "Error",
              screenReaderContent: "Error",
              developmentUrl: developmentUrl
            }), errorText ? errorText : SELECTION_REQUIRED_DEFAULT_TEXT]
          }) : '']
        }) : null, !groupLabelExists && !describedById ? /*#__PURE__*/(0,jsx_runtime_.jsxs)("span", {
          className: "".concat(componentClassName, "__error"),
          children: [/*#__PURE__*/(0,jsx_runtime_.jsx)(Icon["default"], {
            icon: "Error",
            screenReaderContent: "Error",
            developmentUrl: developmentUrl
          }), /*#__PURE__*/(0,jsx_runtime_.jsx)("span", {
            children: "You must include either a groupLabel or describedById prop to ensure correct titling of this group for accessibility"
          })]
        }) : null, modifiedChildren()]
      })
    }))
  }));
}
/* harmony default export */ const _partials_SelectableInputGroup = (SelectableInputGroup);
// EXTERNAL MODULE: ./src/Checkbox/index.ts + 2 modules
var Checkbox = __webpack_require__(2551);
;// ./src/_shared/_partials/LabelWithOptionalText/index.tsx

var LabelWithOptionalText = function LabelWithOptionalText(_ref) {
  var label = _ref.label,
    required = _ref.required,
    _ref$wrapWithLabelEle = _ref.wrapWithLabelElement,
    wrapWithLabelElement = _ref$wrapWithLabelEle === void 0 ? true : _ref$wrapWithLabelEle,
    id = _ref.id;
  var LabelText = function LabelText() {
    return /*#__PURE__*/(0,jsx_runtime_.jsxs)(jsx_runtime_.Fragment, {
      children: [label, " ", required ? '' : '(optional)']
    });
  };
  if (wrapWithLabelElement) {
    return /*#__PURE__*/(0,jsx_runtime_.jsx)("label", {
      htmlFor: id,
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)(LabelText, {})
    });
  } else {}
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(LabelText, {});
};
/* harmony default export */ const _partials_LabelWithOptionalText = (LabelWithOptionalText);
;// ./src/CheckboxGroup/CheckboxGroup.tsx

function CheckboxGroup_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CheckboxGroup_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CheckboxGroup_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CheckboxGroup_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





/**
 * A Checkbox Group allows users to select zero, one or many options from a set.
 * It consists of a group label and a set of checkboxes, and optional help text
 * to provide additional selection requirements.
 *
 * [View the Checkbox Group pattern documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Checkbox+Group)
 *
 * @version 1.0.0
 */
function CheckboxGroup(props) {
  var checkboxes = props.checkboxes,
    children = props.children,
    errorText = props.errorText,
    groupLabel = props.groupLabel,
    invalidMessage = props.invalidMessage,
    label = props.label,
    _props$required = props.required,
    required = _props$required === void 0 ? true : _props$required;
  var updatedProps = CheckboxGroup_objectSpread(CheckboxGroup_objectSpread({}, props), {}, {
    errorText: errorText || invalidMessage,
    groupLabel: /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_LabelWithOptionalText, {
      label: groupLabel || label,
      required: required,
      wrapWithLabelElement: false
    })
  });
  delete updatedProps.required;
  delete updatedProps.label;
  delete updatedProps.invalidMessage;
  delete updatedProps.checkboxes;
  var childrenToRender = function childrenToRender() {
    if (children) {
      return children;
    }
    if (checkboxes && checkboxes.length) {
      return checkboxes.map(function (childProps) {
        var childKey = "ableCheckboxGroupChild".concat(_helpers_randomNum());
        return /*#__PURE__*/(0,jsx_runtime_.jsx)(Checkbox["default"], CheckboxGroup_objectSpread({}, childProps), childKey);
      });
    }
    new Error('CheckboxGroup requires children or prop checkboxes.');
    return;
  };
  var componentClassName = "able-CheckboxGroup--".concat(props.variant ? props.variant : 'Compact');
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(_partials_SelectableInputGroup, CheckboxGroup_objectSpread(CheckboxGroup_objectSpread({
    componentClassName: componentClassName
  }, updatedProps), {}, {
    children: childrenToRender()
  }));
}
/* harmony default export */ const CheckboxGroup_CheckboxGroup = (CheckboxGroup);
// EXTERNAL MODULE: ./src/CheckboxGroup/CheckboxGroup.scss
var src_CheckboxGroup_CheckboxGroup = __webpack_require__(5657);
;// ./src/CheckboxGroup/index.ts


/* harmony default export */ const src_CheckboxGroup = (CheckboxGroup_CheckboxGroup);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});